import styled from "styled-components";
import {
  BASIC_DARK_GRAY,
  BASIC_GRAY_BACKGROUND,
  BASIC_ORANGE,
  BASIC_WHITE,
} from "../../../constants/colors";
import { Button } from "../../atoms/Button";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";
import { StoreDetail } from "../../molecules/store/StoreDetail";
import { OrderContent } from "../../organisms/order/OrderContent";
import { useOrderComplete } from "./hook";

export const OrderComplete: React.FC = () => {
  const {
    order,
    store,
    orderId,
    pickupDateText,
    campaign,
    handleSetFavoriteStore,
    handleSetFavoriteMenu,
  } = useOrderComplete();

  return (
    <OrderCompleteContainer>
      <TitleContainer>
        <OrderCompleteTitle>ご注文完了</OrderCompleteTitle>
        <OrderCompleteSubtitle>
          ご注文ありがとうございました
        </OrderCompleteSubtitle>
      </TitleContainer>

      <Container>
        <OrderId>
          <span>注文ID：</span>
          <span data-wovn-ignore>{orderId}</span>
        </OrderId>

        <WarningMessage>
          お受け取りの際に注文IDが必要となりますので、控えておいてください
        </WarningMessage>
      </Container>

      {order && store && (
        <>
          <StoreMessage>
            お受け取りのお時間になりましたら
            <br />
            下記の店舗までお受け取りにお越しください
          </StoreMessage>

          <StoreDetailContainer>
            <StoreDetail
              id={store.id}
              name={store.name}
              address={store.prefecture + store.city + store.address}
              phoneNumber={store.phoneNumber}
              service={store.service}
              location={{
                lat: store.location.latitude,
                lng: store.location.longitude,
              }}
              isFavorite={store.isFavorite}
              onFavoriteClick={handleSetFavoriteStore}
              isAdvancedPayment={store.isPaymentAvailable}
              pickupDateText={pickupDateText}
            />
          </StoreDetailContainer>
        </>
      )}

      {order && (
        <OrderContentContainer>
          <OrderContent
            menus={order.menus}
            memo={order.memo}
            totalPrice={order.totalPriceWithTax}
            totalQuantity={order.quantity}
            taxAmount={order.taxAmount}
            coupon={order.coupon}
          />
        </OrderContentContainer>
      )}

      <AttentionMessage>
        ※ご注文頂いた商品数が多い場合は調理にお時間を頂く場合がございます。
      </AttentionMessage>

      {!campaign && (
        <ButtonWrapper>
          <Button
            size="xxs"
            rounded="sm"
            btnStyle="secondary"
            text="購入した商品をお気に入りへ追加"
            onClick={handleSetFavoriteMenu}
          />
        </ButtonWrapper>
      )}
      <ButtonContainer>
        <BackToTopPageButton />
      </ButtonContainer>
    </OrderCompleteContainer>
  );
};
const OrderCompleteContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${BASIC_WHITE};
  border-radius: 8px;
  margin-bottom: 50px;
  text-align: center;
  color: ${BASIC_DARK_GRAY};
`;

const TitleContainer = styled.div`
  padding: 34px 0 16px;
`;

const OrderCompleteTitle = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 1;
`;

const OrderCompleteSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-top: 20px;
`;

const Container = styled.div``;

const OrderId = styled.div`
  margin: 0 38px 13px;
  padding: 18px 0;
  font-size: 16px;
  font-weight: 600;
  background-color: ${BASIC_GRAY_BACKGROUND};
`;

const WarningMessage = styled.div`
  color: ${BASIC_ORANGE};
  display: inline-block;
  font-size: 14px;
  font-weight: 300;
  padding: 15px 20px;
  margin: 10px 0 20px 0;
  width: fit-content;
  border: 1px solid ${BASIC_ORANGE};
`;

const StoreDetailContainer = styled.div`
  margin-bottom: 60px;
  padding: 18px 18px 0;
  background-color: ${BASIC_GRAY_BACKGROUND};
`;

const StoreMessage = styled.div`
  font-size: 14px;
  font-weight: 200;
  margin-bottom: 30px;
`;

const AttentionMessage = styled.div`
  font-size: 16px;
  font-weight: 300;
  color: ${BASIC_DARK_GRAY};
  line-height: 1.6em;
  padding: 15px 0;
  margin: 0;
`;

const OrderContentContainer = styled.div`
  margin: 0 16px 55px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 55px 0 35px;
  gap: 30px;
  button:first-child {
    font-weight: 300;
    width: 220px;
    padding: 8px 0;
    height: auto;
  }
`;

const ButtonContainer = styled.div`
  button {
    height: auto;
    font-weight: 600;
    line-height: 1em;
  }
`;
